import { useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from 'styled-components';
import { CheckCircle, DeniCircle } from '../../../../assets/icon/index';
import Button from '../../../../components/Button/Button';
import DropDown from '../../../../components/DropDown/DropDown';
import Loading from '../../../../components/Loading';
import Modal from '../../../../components/Modal/Modal';
import ModalPassword from '../../../../components/ModalPassword/ModalPassword';
import SelectOptions from '../../../../components/SelectOptions';
import { showAlert } from '../../../../store/ducks/sweetAlert';
import {
  approveComiteAction,
  approveUserFetchAction,
  negadeComiteAction,
} from '../../../../store/fetchActions/approveUserActions';
import { taxesFetchAction } from '../../../../store/fetchActions/taxesActions';
import { optionsClientsPending } from '../../../../utils/constant';
import api from '../../../../utils/services/api';
import verifyArray from '../../../../utils/verifyArray';
import ModalEditarTaxas from '../../../PerfisUsuarios/Modals/Perfis/EditTaxes';
import { SectionTitle } from '../../styles/GerenciarClientes.styles';
import DocumentCollum from '../Collums/DocumentCollum';
import * as S from './ClientesPendentesPj.styles';
import AboutCollum from '../Collums/AboutCollum';
import ModalSendDocuments from './SendDocumentsClients';
import LegalRepresentative from '../representativesCard/RepresentativesCard';

const DetalhesPendendes = ({ open, close, info, deny }) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const [hoverColorDeni, setHoverColorDeni] = useState(theme.colors.white);
  const [expanded, setExpanded] = useState('panel1');
  const [statusRep, setStatusRep] = useState([]);
  const [comite, setComite] = useState([]);
  const [negadeComite, setNegadeComite] = useState([]);
  const [radio, setRadio] = useState([]);
  const [negateRep, setNegateRep] = useState([]);
  const [idProfile, setIdProfile] = useState();
  const [idCloned, setIdCloned] = useState();
  const [modalTaxas, setModalTaxas] = useState(false);
  const [modalPasswordEditarTaxas, setModalPasswordEditarTaxas] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isModalPasswordOpen, setIsModalPasswordOpen] = useState(false);
  const [nameSelectedItem, setNameSelectedItem] = useState('');
  const [functionSelectedItem, setFunctionSelectedItem] = useState(() => {});
  const [documentTypeToSend, setDocumentTypeToSend] = useState('');
  const [isModalSendDocumentsOpen, setIsModalSendDocumentsOpen] = useState(false);

  const { handleSubmit: handleSubmitApproval, control: controlAproval } = useForm({});

  const { cobansData } = useSelector((state) => state.cobans);
  const perfisArray = cobansData?.filter((val) => val.CPFCNPJ === null);

  const { loadingUser }     = useSelector((state) => state.user);
  const { loadingEditUser } = useSelector((res) => res.editUser);

  const submitApprovation = () => (idProfile ? approveUser({ perfil: idProfile }) : approveError());
  const openModalPassword = () => setIsModalPasswordOpen(true);

  const callFunction = () => {
    const callFunction = {
      editData: () => setIsEditing(true),
      sendImages: () => {
        setDocumentTypeToSend('image/*');
        setIsModalSendDocumentsOpen(true);
      },
      sendDocuments: () => {
        setDocumentTypeToSend('.pdf');
        setIsModalSendDocumentsOpen(true);
      },
    };

    setFunctionSelectedItem(callFunction[nameSelectedItem]);
  };

  const approveError = () => {
    dispatch(
      showAlert({
        title: 'Perfil não selecionado!',
        text: 'Selecione um perfil para aprovar o cliente',
        icon: 'error',
      }),
    );
  };


  const approveUser = (data) => {
    const param = { CPFUSUARIO: info?.CPFCNPJ, ID_COBAN: data?.perfil, REPRESENTANTES: negateRep, ID_PRODUTO_DIGITAL: info?.ID_PRODUTO_DIGITAL };

    dispatch(
      approveUserFetchAction(param, close, (res) => {
        res &&
          (verifyArray(negadeComite) &&
            negadeComite?.forEach((val) => {
              dispatch(negadeComiteAction({ ID_USUARIO: val.ID }));
            }),
          verifyArray(comite) && dispatch(approveComiteAction({ representantes: comite, ID_PRODUTO_DIGITAL: info?.ID_PRODUTO_DIGITAL }, true, close)));
      }),
    );
  };

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const changeStatus = (val, indx, colorBack, colorText, status) => {
    statusRep[indx] = { val, colorBack, colorText, status };
    setStatusRep(statusRep);
  };

  const changeComite = (event, val, indx) => {
    if (event.target.value === 'true' && val?.SIGNATARIO !== tipos_signatarios[0].ID) {
      setComite([
        ...comite,
        {
          CPFCNPJ_USUARIO: val.CPFCNPJ,
          CPFCNPJ_EMPRESA: val.CPFCNPJ_EMPRESA,
          EMAIL: val.EMAIL,
        },
      ]),
        setRadio([...radio, { INDEX: indx, STATUS: event.target.value }]);
      verifyArray(negadeComite) && setNegadeComite(negadeComite?.filter((e) => e.CPFCNPJ_USUARIO !== val.CPFCNPJ));
    }

    if (event.target.value === 'false') {
      setNegadeComite([
        ...negadeComite,
        {
          CPFCNPJ_USUARIO: val.CPFCNPJ,
          CPFCNPJ_EMPRESA: val.CPFCNPJ_EMPRESA,
          EMAIL: val.EMAIL,
          ID: val['ID_USUARIO_COMITE '],
        },
      ]);

      verifyArray(comite) &&
        (setComite(comite?.filter((e) => e.CPFCNPJ_USUARIO !== val.CPFCNPJ)),
        setRadio(
          radio?.filter((e) => e.INDEX !== indx),
          { INDEX: indx, STATUS: false },
        ));
    }
  };

  const valRadioCheck = (val) => {
    const valCheck = radio?.filter((e) => e.INDEX === val);
    if (valCheck !== undefined) {
      return valCheck[0]?.STATUS ?? false;
    } else {
      return false;
    }
  };

  const reset = () => {
    setStatusRep([]);
    setComite([]);
    setRadio([]);
    setExpanded('panel1');
  };
  
  const cloneProfile = async () => {
    try {
       const params = {
         "ID_COBAN": idProfile, 
         "NOME": info.NOME,
       };
   
       const response = await api.post('/coban/perfil/clonar', params);
       setIdCloned(response.data.ID_COBAN);
       console.log(idCloned)
       setModalPasswordEditarTaxas(true)
       console.log(response.data.ID_COBAN);
    } catch (error) {
       console.error(error);
    }
   };

  const editTaxes = (id) => {
    dispatch(taxesFetchAction(idProfile));
    setModalTaxas(true);
  };

  useEffect(() => {
    reset();
  }, [open]);

  const resetNegateRep = (val) => {
    const restartNegate = negateRep?.filter((e) => e?.CPF_REPRESENTANTE !== val);
    setNegateRep(restartNegate);
  };
  
  useEffect(() => {
    const initialRadio = info?.REPRESENTANTES?.map((val, index) => {
      if (val.SIGNATARIO === '2' || val.SIGNATARIO === '3') {
        return { INDEX: index, STATUS: true };
      } else {
        return { INDEX: index, STATUS: false };
      }
    });

    const initialComite = info?.REPRESENTANTES?.filter((val) => val.SIGNATARIO === '2' || val.SIGNATARIO === '3')?.map(
      (val, index) => {
        return { CPFCNPJ_USUARIO: val.CPFCNPJ, CPFCNPJ_EMPRESA: val.CPFCNPJ_EMPRESA, EMAIL: val.EMAIL };
      },
    );

    setRadio(initialRadio);

    verifyArray(initialComite) && setComite(initialComite);
  }, [info?.REPRESENTANTES]);

  return (
    <Modal
      open={open}
      close={() => {
        close(), reset();
      }}
      title="Dados Cliente"
      width={'96.222vw'}
    >
      {loadingUser ? (
        <Loading />
      ) : (
        <>
          <S.EditButtonContainer>
            <h4>Informações empresariais</h4>
            <DropDown
              isEditing={isEditing}
              openModalPassword={() => setIsModalPasswordOpen(true)}
              options={optionsClientsPending}
              setNameSelectedItem={(e) => setNameSelectedItem(e)}
            />
          </S.EditButtonContainer>
          <S.InfoContainer>
              {/* <InformationColum title="Informações empresariais" data={info} /> */}
              {loadingEditUser ? <Loading /> : <AboutCollum isEditing={isEditing} cancel={() => setIsEditing(false)} width='75%' />}
              <DocumentCollum />
            </S.InfoContainer>
          {/* <form onSubmit={handleSubmitApproval(submitApprovation)}> */}
            <S.InsertContainer>
              <S.InputSelect>
                <SectionTitle>Perfil Associado</SectionTitle>
                <SelectOptions
                  control={controlAproval}
                  options={perfisArray}
                  name={'perfil'}
                  width="35.111vw"
                  label={'Perfil'}
                  onClick={(data) => setIdProfile(data.ID)}
                  required
                />
              </S.InputSelect>
              <div style={{ marginTop: '2.5rem' }}>
                  <Button
                    backgroundcolor={theme.colors.buttonNegaded}
                    width="15.111vw"
                    height="3.125vw"
                    hoverbgcolor={theme.colors.buttonNegaded}
                    hovercolor={theme.colors.buttonNegadedHoverText}
                    mycolor={theme.colors.buttonNegadedText}
                    onClick={() => cloneProfile()}
                    onMouseOver={() => setHoverColorDeni(theme.colors.white)}
                    onMouseOut={() => setHoverColorDeni(theme.colors.white)}
                    
                  ><span>Clonar Perfil</span></Button>
            </div>
            </S.InsertContainer>

            <LegalRepresentative />

            <S.Footer>
              <Button
                backgroundcolor={theme.colors.buttonNegaded}
                width="35.111vw"
                height="3.125vw"
                hoverbgcolor={theme.colors.buttonNegadedHover}
                hovercolor={theme.colors.buttonNegadedHoverText}
                mycolor={theme.colors.buttonNegadedText}
                onClick={deny}
                onMouseOver={() => setHoverColorDeni(theme.colors.white)}
                onMouseOut={() => setHoverColorDeni(theme.colors.white)}
              >
                <DeniCircle color={hoverColorDeni} />
                <span>Negar</span>
              </Button>
              <Button
                backgroundcolor={theme.colors.buttonApproved}
                width="35.111vw"
                height="3.125vw"
                hoverbgcolor={theme.colors.buttonApprovedHover}
                hovercolor={theme.colors.buttonApprovedHoverText}
                mycolor={theme.colors.buttonApprovedText}
                onClick={submitApprovation}
                // type="submit"
              >
                <CheckCircle />
                <span>Aprovar</span>
              </Button>
            </S.Footer>
          {/* </form> */}
        </>
      )}
      {modalTaxas && <ModalEditarTaxas open={modalTaxas} profileName={info.NOME} close={() => setModalTaxas(false)} id={idCloned} />}
      {isModalPasswordOpen && (
        <ModalPassword
          openModal={isModalPasswordOpen}
          closeModal={() => setIsModalPasswordOpen(false)}
          nextFunction={callFunction}
        />
      )}

      {isModalSendDocumentsOpen && (
        <ModalSendDocuments
          openModal={isModalSendDocumentsOpen}
          closeModal={() => setIsModalSendDocumentsOpen(false)}
          accept={documentTypeToSend}
        />
      )}
      <ModalPassword
        openModal={modalPasswordEditarTaxas}
        closeModal={() => setModalPasswordEditarTaxas(false)}
        nextFunction={editTaxes}
      />
    </Modal>
  );
};

export default DetalhesPendendes;
